var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inconsistencias.length > 0)?_c('rkm-alert',{attrs:{"color":"danger"}},[_c('ul',{staticClass:"m-0 px-3"},_vm._l((_vm.inconsistencias),function(inconsistencia,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(inconsistencia)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }